import Store from '~/store/Store';
import type UserRoleConstants from '~/constants/user-role-constants';

export const getUserRoles = (): UserRoleConstants[] => {
  return Store.getState().authentication.permissionTypes;
};
